export const prettifyString = (str: string): string => {
    const formattedString = str.replace(/_/g, ' ').toLowerCase()
    return formattedString.charAt(0).toUpperCase() + formattedString.slice(1)
}
